import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import axios from "axios";
import "./SellerFinancialReports.css";
import { BaseUrl } from "../../App";

export default function SellerFinancialReports() {

  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  async function getFinancialReports() {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${BaseUrl}saller/financial-accounts-list-details`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("FINANCIAL REPORTS:", res.data);

      setReports(res.data.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getFinancialReports();
  }, []);

  return (
    <Container className="reports-page">

      {/* ===== Breadcrumb ===== */}
      {/* <h2 className="page-titles pt-5">
        التقارير / <span className="accounts">الحسابات المالية</span> / <span className="main-gray">الرئيسية</span>
      </h2> */}

      {/* ===== Table ===== */}
      <div className="table-wrapper">

        <table className="finance-table">

          {/* <thead>
            <tr className="tableheading">
              <th>رقم الطلب</th>
              <th>المبلغ</th>
              <th>عدد المنتجات</th>
              <th>حالة الدفع</th>
              <th>التاريخ</th>
            </tr>
          </thead> */}
          <thead>
  <tr className="tableheading">
    <th>رقم الطلب</th>
    <th>المبلغ</th>
    <th>الكود</th>
    <th>الكمية</th>
    <th>الحالة</th>
    <th>التاريخ</th>
  </tr>
</thead>

          {/* <tbody>

            {loading ? (
              <tr>
                <td colSpan="5">Loading...</td>
              </tr>
            ) : reports.length > 0 ? (
              reports.map((item, index) => (
                <tr key={index}>
                  <td>{item.order_number}</td>

                  <td className="amount">
                    {item.final_total} ر.س
                  </td>

                  <td>{item.count_items}</td>

                  <td className="status">
                    {item.is_paid === 1 ? "مدفوع" : "غير مدفوع"}
                  </td>

                  <td>{item.created_at}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">لا توجد بيانات</td>
              </tr>
            )}

          </tbody> */}
          <tbody>

  {loading ? (
    <tr>
      <td colSpan="6">Loading...</td>
    </tr>
  ) : reports.length > 0 ? (
    reports.map((item, index) => (
      <tr key={index}>

        <td>{item.order_id}</td>

        <td className="amount">
          {item.final_total}
        </td>

        <td>{item.order_number}</td>

        <td>{item.count_items}</td>

        <td className="status">
          {item.is_paid === 1 ? "مدفوعة" : "غير مدفوعة"}
        </td>

        <td>
          {item.created_at?.split(" ")[0]}
        </td>

      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6">لا توجد بيانات</td>
    </tr>
  )}

</tbody>
        </table>
      </div>

      {/* <button className="print-btn text-white">
        طباعة
      </button> */}

    </Container>
  );
}